module.exports = __webpack_public_path__ + "img/BTC-icon.ae1d2da1.svg";